import(/* webpackMode: "eager", webpackExports: ["HomeSocial"] */ "/vercel/path0/apps/web/src/sections/social/HomeSocial.tsx");
